





import { computed, defineComponent } from '@nuxtjs/composition-api'
import CARReferenceLink from './CARReferenceLink.vue'
import IntraseqReferenceLink from './IntraseqReferenceLink.vue'
import { useI18n } from '~/composables/i18n'
import { usePdpStore } from '~/store/pdp'
import { CAR_TEMPLATE, INTRASEQ_TEMPLATES } from '~/common/utils/product/constants'

export default defineComponent({
  components: {
    IntraseqReferenceLink,
    CARReferenceLink,
  },
  setup() {
    const { template } = usePdpStore()
    const isIntraseqTemplate = computed(() => INTRASEQ_TEMPLATES.includes(template?.title as string))
    const isCARTemplate = computed(() => template?.title === CAR_TEMPLATE)
    const { t } = useI18n()
    return { t, template, isIntraseqTemplate, isCARTemplate }
  },
})
